// Products the supplier files under a product type they are not, keyed by the
// exact supplier title (lower case). A listing is a server query by type, so
// such a product shows up in the wrong category: Loft Beds listed a $1,884.99
// bookcase. The corrected type takes it out of that listing
// (src/lib/productTypes.ts keepExactTypes) and gives its page the right
// breadcrumb (the React product page and scripts/prerender-og.mjs). It cannot
// add it to the right listing, which only the supplier's own type reaches.
// Read by src/lib/productTypes.ts, src/pages/ProductDetail.tsx and
// scripts/prerender-og.mjs.
const OVERRIDES = {
  '66" white five tier standard bookcase with five drawers': "Bookcases",
  "white ten pair wall mounted woodshoe rack": "Shoe Racks",
  "dark brown ten pair wall mounted woodshoe rack": "Shoe Racks",
};

/** The product type to file a product under: the supplier's, unless it is known to be wrong. */
export function correctedType(title, productType) {
  return OVERRIDES[String(title ?? "").trim().toLowerCase()] ?? productType;
}
